import script from "./AlertsInMobileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsInMobileCard.vue?vue&type=script&setup=true&lang=ts"

import "./AlertsInMobileCard.vue?vue&type=style&index=0&id=6d7c0f92&lang=css"

const __exports__ = script;

export default __exports__